import { jsx as _jsx } from "preact/jsx-runtime";
import register from 'preact-custom-element';
import LogoSvg from './logo.svg?react';
export default function Logo() {
    return _jsx(LogoSvg, {});
}
register(Logo, 'locator-logo', ['type', 'locale']);
